import axiosApi from 'modules/api'
import { ActiveOffer } from 'modules/offer/types'
import { networkTokens } from 'modules/token/networkCuratedTokens'
import { GetActiveOrdersResponse } from 'pages/api/orders/active'
import { isAddressEqual } from 'utils/web3'
import { getChainName } from 'utils/web3/chains'

const fetchActiveOffers = async (searchTokenOrders?: string) => {
  const { data } = await axiosApi.get<GetActiveOrdersResponse>(
    '/orders/active',
    {
      params: {
        token: searchTokenOrders,
      },
    }
  )
  const _orders = data.orders
  const tokenOrders: string[] = []
  for (let i = 0; i < _orders.length; i++) {
    const order = _orders[i]
    const sellTokenExcluded =
      networkTokens.findIndex(
        (x) =>
          isAddressEqual(x.address, order.sellToken) &&
          x.chainId === order.chainId
      ) > -1
    if (!sellTokenExcluded) {
      tokenOrders.push(order.sellToken)
    }
    const buyTokenExcluded =
      networkTokens.findIndex(
        (x) =>
          isAddressEqual(x.address, order.buyToken) &&
          x.chainId === order.chainId
      ) > -1
    if (!buyTokenExcluded) {
      tokenOrders.push(order.buyToken)
    }
  }
  const uniqueTokens = [...new Set(tokenOrders)]
  const _newOrders: ActiveOffer[] = []

  uniqueTokens.forEach((address) => {
    const foundOrder = _orders.find((x) =>
      [x.sellToken, x.buyToken].includes(address)
    )
    if (foundOrder) {
      const main =
        (isAddressEqual(foundOrder.sellToken, address)
          ? foundOrder.sellTokenParent
          : foundOrder.buyTokenParent) || address
      _newOrders.push({
        main,
        tokenAddress: address,
        tokenName: isAddressEqual(foundOrder.sellToken, address)
          ? foundOrder.sellTokenName
          : foundOrder.buyTokenName,
        tokenSymbol: isAddressEqual(foundOrder.sellToken, address)
          ? foundOrder.sellTokenSymbol
          : foundOrder.buyTokenSymbol,
        offers: tokenOrders.filter((x) => isAddressEqual(x, address)).length,
        network: getChainName(foundOrder.chainId),
        chainId: foundOrder.chainId,
        redirectUrl: `${main}?network=${foundOrder.chainId}${
          isAddressEqual(main, address) ? '' : `&lvt=${address}`
        }`,
      })
    }
  })
  return _newOrders
}

export default fetchActiveOffers
